import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useGetInvoicesPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/invoices/models/inputs/get-invoices-paginated.form-validation';
import { GetInvoicesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/invoices/models/inputs/get-invoices-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';

import { CustomerFilterController } from '@app/feature/customer/customer-filter/customer-filter.controller';
import { NetworkFilterController } from '@app/feature/network/network-filter/network-filter.controller';

import { InvoiceStatusFilterController } from '../../invoice-status-filter/invoice-status-filter.controller';
import { InvoiceTypeFilterController } from '../../invoice-type-filter/invoice-type-filter.controller';

const InvoiceListFilterFormStep1CustomerIdFragment = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetInvoicesPaginatedModel>();
  const { customerId } = useGetInvoicesPaginatedFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <>
      <Controller
        name="customerId"
        control={control}
        rules={customerId}
        render={({ field /* , fieldState: { error } */ }) => {
          const values = [];

          if (Array.isArray(field.value)) {
            values.push(...field.value);
          } else if (field.value) {
            values.push(field.value);
          }

          return (
            <CustomerFilterController
              selectedItemIds={values}
              onChange={(value) => field.onChange(value)}
            />
          );
        }}
      />
      <Divider />
    </>
  );
};

const InvoiceListFilterFormStep1NetworkIdFragment = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetInvoicesPaginatedModel>();
  const { customerId } = useGetInvoicesPaginatedFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <>
      <Controller
        name="networkId"
        control={control}
        rules={customerId}
        render={({ field /* , fieldState: { error } */ }) => {
          const values = [];

          if (Array.isArray(field.value)) {
            values.push(...field.value);
          } else if (field.value) {
            values.push(field.value);
          }

          return (
            <NetworkFilterController
              selectedItemIds={values}
              onChange={(value) => field.onChange(value)}
            />
          );
        }}
      />
      <Divider />
    </>
  );
};

const InvoiceListFilterFormStep1StatusFragment = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetInvoicesPaginatedModel>();
  const { status } = useGetInvoicesPaginatedFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <>
      <Controller
        name="status"
        control={control}
        rules={status}
        render={({ field /* , fieldState: { error } */ }) => {
          const values = [];

          if (Array.isArray(field.value)) {
            values.push(...field.value);
          } else if (field.value) {
            values.push(field.value);
          }

          return (
            <InvoiceStatusFilterController
              selectedItemIds={values}
              onChange={(value) => field.onChange(value)}
            />
          );
        }}
      />
      <Divider />
    </>
  );
};

const InvoiceListFilterFormStep1TypeFragment = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetInvoicesPaginatedModel>();
  const { type } = useGetInvoicesPaginatedFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Controller
      name="type"
      control={control}
      rules={type}
      render={({ field /* , fieldState: { error } */ }) => {
        const values = [];

        if (Array.isArray(field.value)) {
          values.push(...field.value);
        } else if (field.value) {
          values.push(field.value);
        }

        return (
          <InvoiceTypeFilterController
            selectedItemIds={values}
            onChange={(value) => field.onChange(value)}
          />
        );
      }}
    />
  );
};

export const InvoiceListFilterFormStep1Controller = (): React.JSX.Element => {
  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <Stack
      direction="row"
      justifyContent="stretch"
      alignItems="stretch"
      flex={1}
      gap={GapEnum.M}>
      <Stack direction="column" flex={1} alignItems="stretch" gap={GapEnum.M}>
        <InvoiceListFilterFormStep1CustomerIdFragment />
        <InvoiceListFilterFormStep1NetworkIdFragment />
        <InvoiceListFilterFormStep1StatusFragment />
        <InvoiceListFilterFormStep1TypeFragment />
      </Stack>
    </Stack>
  );
};
